import React from "react";
import SwimmerTrackerSummary from "./SwimmerTrackerSummary";

const SwimmersView = () => {
  return (
    <div className="swimmers-page" style={styles.page}>
      <h1 className="page-title">Swimmers</h1>

      <div style={styles.contentWrap}>
        <SwimmerTrackerSummary hideNav embedded />
      </div>
    </div>
  );
};

export default SwimmersView;

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    gap: "0.55rem",
  },
  contentWrap: {
    border: "1px solid rgba(0,245,212,0.34)",
    borderRadius: "14px",
    padding: "0.58rem",
    backgroundColor: "rgba(7, 20, 60, 0.72)",
    boxShadow: "inset 0 0 0 1px rgba(0,245,212,0.08)",
  },
};
